type BlogListProps = {
  width?: string;
  height?: string;
  amount?: number;
  margin?: string;
};

export const Skeleton = ({ width, height, amount, margin }: BlogListProps) => {
  const skeleton = [];
  for (let i = 0; i < amount; i++) {
    skeleton.push(
      <div className="skeleton-container">
        <style jsx>{`
          .skeleton-container {
            width: ${width ? width : "200px"};
            height: ${height ? height : "100px"};
            border-radius: 8px;
            background-color: #d8d8d8;
            margin: ${margin ? margin : "16px"};
          }
        `}</style>
      </div>
    );
  }
  return <div className="skeleton-wrapper">{skeleton}</div>;
};
